export default "__VITE_ASSET__DLSARQyx__"